module.exports = __webpack_public_path__ + "img/laser-turret-damage.281b1a7d.png";